export default {
  TableHead: [
    [
      {
        displayName: 'currency.currencytablehead.basecurrency',
      },
      {
        displayName: 'currency.currencytablehead.exchange',
      },
      {
        displayName: 'currency.currencytablehead.currencyrate',
      },
    ],
  ],
};
